import { connect } from 'react-redux';

import LearningAdminModuleSerieFormStep2 from '../components/LearningAdminModuleSerieFormStep2';
import storage from '../../../../../lib/Storage';
import { List } from 'immutable';
import {
  loadModuleSerieAdmin,
  createModulesAdmin,
  moduleSerieAdminFormDestroy,
  updateModulesAdmin,
  deleteModulesAdmin,
} from '../../../../../state/modules/learningsAdmin/actions';
import {
  getImageUploadURL,
  uploadImage,
  createMediaImagePartnership,
  getImageSignedURL,
  deleteMediaImagePartnership,
} from '../../../../../state/modules/media/actions';
import { findStorageType } from '../../../../../lib/Auth';

const inputs = List([
  'title',
  'description',
  'cover_image',
  'cover_image_id',
  'media',
  'media_id',
  'content',
  'categories',
  'order',
  'video_vimeo_url',
  'video_youtube_url',
  'modules',
  'public_status',
]);

const mapStateToProps = (state, ownProps) => {
  const data = {},
    errors = {};
  for (const val of inputs.values()) {
    data[val] = state.entities.getIn(
      ['learningModuleSeriesAdmin', ownProps.moduleSerieId, val],
      ''
    );
    errors[val] = state.learningsAdmin.getIn(['form', 'errors', val]);
  }

  return {
    isLoading:
      state.learningsAdmin.get('isLoading') ||
      state.media.get('isImageUploadUrlLoading') ||
      state.media.get('isImageUploading'),
    isSubmitting:
      state.learningsAdmin.getIn(['form', 'isSubmitting']) ||
      state.media.get('isSubmitting') ||
      state.media.getIn(['form', 'isSubmitting']),
    data: data,
    errors: errors,
    success: state.learningsAdmin.getIn(['form', 'success']),
    created_id: state.learningsAdmin.getIn(['form', 'created_id']),
    partnershipId: storage.get(findStorageType(), 'partnershipId'),
    partnershipName: state.learningsAdmin.getIn(['form', 'partnershipName']),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    load: (partnershipId, id, cb) => {
      dispatch(loadModuleSerieAdmin(partnershipId, id, cb));
    },
    create: (partnershipId, moduleSerieId, data, cb) => {
      dispatch(createModulesAdmin(partnershipId, moduleSerieId, data, cb));
    },
    update: (partnershipId, moduleSerieId, data, cb) => {
      dispatch(updateModulesAdmin(partnershipId, moduleSerieId, data, cb));
    },
    destroyForm: (formState) => {
      dispatch(moduleSerieAdminFormDestroy(formState));
    },
    createImagePartnership: (partnershipId, data, cb) => {
      dispatch(createMediaImagePartnership(partnershipId, data, cb));
    },
    getUploadUrl: (extension, directory, cb) => {
      dispatch(getImageUploadURL(extension, directory, cb));
    },
    upload: (path, file, cb) => {
      dispatch(uploadImage(path, file, cb));
    },
    getSignedUrl: (path, cb) => {
      dispatch(getImageSignedURL(path, cb));
    },
    removes: (partnershipId, payload, cb) => {
      dispatch(deleteModulesAdmin(partnershipId, payload, cb));
    },
    deleteImage: (partnershipId, id, cb) => {
      dispatch(deleteMediaImagePartnership(partnershipId, id, cb));
    },
  };
};

const LearningAdminModuleSerieFormStep2Container = connect(
  mapStateToProps,
  mapDispatchToProps
)(LearningAdminModuleSerieFormStep2);

export default LearningAdminModuleSerieFormStep2Container;
